import { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const IconChannelSitecore = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 24 24"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.3907 17.5786C12.3261 17.4572 13.2292 17.1721 14.0477 16.7154C16.0696 15.5857 17.2371 13.6439 17.3364 11.2474L17.3449 11.0401H20.143C19.9708 9.65454 19.4502 8.33474 18.6294 7.20323L15.7669 9.04815C16.6383 10.4188 16.7501 11.938 16.0892 13.4557C15.3055 15.2534 13.4594 16.8283 11.3907 17.5786Z"
          fill="#EE3524"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20.1864 11.4727H17.7566C17.5929 13.8967 16.3261 15.9379 14.2584 17.0932C13.0783 17.7522 11.7349 18.0804 10.3633 18.0804C9.27726 18.0775 8.20078 17.8777 7.18652 17.4907C8.42964 18.2696 9.8269 18.6957 11.2745 18.7003H11.2967C13.9104 18.7003 16.2566 17.3116 17.5763 14.9828L17.6881 14.7861L19.314 15.821C19.9042 14.6586 20.2112 13.374 20.2101 12.0714C20.2101 11.8696 20.2 11.6704 20.1864 11.4727Z"
          fill="#EE3524"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.295 19.1325H11.2718C8.66772 19.1249 6.22077 17.8306 4.47949 15.6017C5.8027 18.4133 8.65311 20.3641 11.9503 20.3641C15.0067 20.3641 17.6783 18.6868 19.1063 16.202L17.835 15.3929C16.4186 17.7402 13.9918 19.1325 11.295 19.1325Z"
          fill="#EE3524"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.9507 0.0710449C5.35026 0.0710449 0 5.44369 0 12.071C0 18.6984 5.35026 24.071 11.9507 24.071C18.5506 24.071 23.9009 18.6989 23.9009 12.071C23.9009 5.44319 18.5511 0.0710449 11.9507 0.0710449ZM11.9507 20.7968C7.15147 20.7968 3.26093 16.8901 3.26093 12.071C3.26093 7.25248 7.15147 3.34583 11.9507 3.34583C16.7494 3.34583 20.6394 7.25248 20.6394 12.071C20.6394 16.8901 16.7494 20.7968 11.9507 20.7968Z"
          fill="#EE3524"
        />
      </SvgIcon>
    );
  })
);
